import axios from 'axios';
import accessLocalStorage from './accessLocalStorage';

const requestConfig = () => {
  const session = accessLocalStorage.getUserLocalStorage();
  const host = session.ipRequest.split('/')[2];
  return {
    baseUrl: `//${host}/api/tenants/cross-call-grants`,
    headers: { Authorization: session.token },
  };
};

const responseError = (error) => ({
  status: error.response ? error.response.status : 0,
  data: error.response && error.response.data
    ? error.response.data
    : { message: 'Falha de comunicacao com o servidor' },
});

export const listCrossCallGrants = async () => {
  const { baseUrl, headers } = requestConfig();
  try {
    const response = await axios.get(baseUrl, { headers });
    return { status: response.status, data: response.data };
  } catch (error) {
    return responseError(error);
  }
};

export const createCrossCallGrant = async (payload) => {
  const { baseUrl, headers } = requestConfig();
  try {
    const response = await axios.post(baseUrl, payload, { headers });
    return { status: response.status, data: response.data };
  } catch (error) {
    return responseError(error);
  }
};

export const deleteCrossCallGrant = async (id, bidirectional) => {
  const { baseUrl, headers } = requestConfig();
  try {
    const response = await axios.delete(
      `${baseUrl}/${id}?bidirectional=${bidirectional ? 'true' : 'false'}`,
      { headers }
    );
    return { status: response.status, data: response.data };
  } catch (error) {
    return responseError(error);
  }
};
